<!--<h2 mat-dialog-title>{{'UI.Label.SetPassword.Title|Jelszó módosítás' | translate}}</h2>-->
<div class="password-change-wrapper">
  <div [formGroup]="passwordForm" class="password-fields">
    <mat-form-field [appearance]="appearance">
      <mat-label>{{ 'UI.Label.SetPassword.NewPassword|Új jelszó' | translate }}</mat-label>
      <input autofocus matInput [type]="hide ? 'password' : 'text'" name="password1" formControlName="password1" (keydown.enter)="enterEvent()" #firstPasswordInput />
      <span matIconSuffix (click)="hide = !hide" class="material-symbols-rounded show-hide-icon">{{hide ? 'visibility_off' : 'visibility'}}</span>
    </mat-form-field>

    <mat-form-field [appearance]="appearance">
      <mat-label>{{ 'UI.Label.SetPassword.NewPasswordConfirm|Új jelszó még egyszer' | translate }}</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" name="password2" formControlName="password2" (keydown.enter)="enterEvent()" />
      <span matIconSuffix (click)="hide = !hide" class="material-symbols-rounded show-hide-icon">{{hide ? 'visibility_off' : 'visibility'}}</span>
    </mat-form-field>
  </div>
  <div class="errors">
    @if (requirementstitle) {
      <h4>{{ 'UI.Label.SetPassword.RestrictionsTitle|Új jelszó kötelező jellemzői:' | translate }}</h4>
    }
    <div class="requirement" [class.ok]="requirementIsOK('minlength')">
      <span class="material-symbols-rounded">{{requirementIcon('minlength')}}</span>
      @if (isDarkMode && requirementIcon('minlength') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span>{{ 'UI.Label.Common.Error.MinLength|Legalább {{value}\} karakter' | translate:{ value: 6 } }}</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('lowercaseLetter')">
      <span class="material-symbols-rounded">{{requirementIcon('lowercaseLetter')}}</span>
      @if (isDarkMode && requirementIcon('lowercaseLetter') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span>{{ 'UI.Label.Common.Error.LowerCaseLetter|Kisbetűt tartalmaz' | translate }}</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('uppercaseLetter')">
      <span class="material-symbols-rounded">{{requirementIcon('uppercaseLetter')}}</span>
      @if (isDarkMode && requirementIcon('uppercaseLetter') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span>{{ 'UI.Label.Common.Error.UpperCaseLetter|Nagybetűt tartalmaz' | translate }}</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('containsNumber')">
      <span class="material-symbols-rounded">{{requirementIcon('containsNumber')}}</span>
      @if (isDarkMode && requirementIcon('containsNumber') === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span>{{ 'UI.Label.Common.Error.ContainsNumber|Számot tartalmaz' | translate }}</span>
    </div>
    <div class="requirement" [class.ok]="requirementIsOK('confirmPassword', true)">
      <span class="material-symbols-rounded">{{requirementIcon('confirmPassword', true)}}</span>
      @if (isDarkMode && requirementIcon('confirmPassword', true) === 'check_circle') {
        <span class="icon-bg"></span>
      }
      <span>{{'UI.Label.Error.ConfirmPasswordMustMatch|A két jelszó megegyezik!' | translate }}</span>
    </div>
  </div>
</div>
